/* eslint-disable camelcase */
import { gql, useFragment } from '@apollo/client';
import { referalLink } from 'app/utils/social';
import React, { useMemo } from 'react';

export const useReferalLink = (props) => {
    const { user_ID } = props;

    const { data: referalUserData } = useFragment({
        fragment: gql`
                 fragment REFERRAL_LINK on user {
                     id
                     referralProgram {
                     link
                 }
             }`,
        from: {
            __ref: `user:${user_ID}`,
        },
    });

    const link = useMemo(
        () => referalLink(referalUserData?.referralProgram?.link) || 'Нету!',
        [referalUserData?.referralProgram?.link],
    );

    return { link };
};
